import { Divider } from '@mui/material';
import { Row } from 'react-bootstrap';

export default function PageHeader(props: any) {
    return (
        <>
            <Row className='justify-content-center p-2'>
                <h4
                    className='text'
                    style={{
                        width: 'fit-content',
                        textAlign: 'center',
                    }}
                >
                    {props.Title}
                </h4>
            </Row>
            <Row className='justify-content-center p-3'>
                <h6
                    className='text'
                    style={{
                        width: 'fit-content',
                        textAlign: 'center',
                    }}
                >
                    {props.Description}
                </h6>
            </Row>
            <Divider style={{ background: '#e8e8e8' }} variant='middle' className='mb-4' />
        </>
    );
}
